<template>
  <div class="default-layout">
    <div
      id="viewport"
      class="w-100 relative"
    >
      <summary-page />
    </div>
  </div>
</template>

<script>

import SummaryPage from '../components/Summary.vue';

export default {
    components: {
        SummaryPage
    },
}
</script>
